import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  FeatureList,
  UsageSteps,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const LineNavigator = () => {
  

  const features = [
    {
      title: '실시간 차로 안내',
      bullets: [
      {
        label: (
          <>LED 안내판과 유도 신호를 통해 운전자에게 공사 구간 및 차로 변경 정보를 즉시 전달함</>
        ),
      },
      ]
    },
    {
      title: '사고 예방 중심 설계',
      bullets: [
      {
        label: (
          <>전방 주시 및 감속을 자연스럽게 유도하여 공사 구간 내 차량 충돌 및 작업자 사고 위험을 최소화</>
        ),
      },
      ]
    },
    {
      title: '고휘도 LED 및 시인성',
      bullets: [
      {
        label: (
          <>야간, 악천후, 안개 상황에서도 운전자가 쉽게 인지할 수 있는 고휘도 LED를 활용하여 시인성 확보</>
        ),
      },
      ]
    },
    {
      title: '다양한 설치 환경 대응',
      bullets: [
      {
        label: (
          <>고속도로, 국도, 교차로, 터널 입구 등 다양한 도로 환경에 맞춰 설치가 가능하며, 이동형 및 고정형 모두 호환 가능함</>
        ),
      },
      ]
    },
    {
      title: '유지관리 용이',
      bullets: [
      {
        label: (
          <>모듈 교체형 구조와 간단한 설치 방식으로 유지보수가 쉽고, 운영 효율성을 높임</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`공사중 차로안내시스템 `}
        subtitle={`공사 현장 작업자의 안전을 확보하고 \n원활한 차량흐름을 유도합니다`}
        backgroundImage="/images/products/guardrail/line-navigator3.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '공사중 차로안내시스템 ' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`스마트 교통안전 장치`}
        title={`공사중 차로안내시스템 `}
        description={
          <>
            고속도로 및 주요 도로에서 공사 구간을 운전자에게 명확히 안내하고 {' '}
            안전하게 차선을 변경하도록 유도하는 스마트 교통안전 장치입니다.
            <br />
            <br />
            전방 주시를 집중시키고 감속을 유도하여 공사 현장 작업자의 안전을 확보하며, 차량 흐름을 원활하게 유지합니다.
          </>
        }
        images={[
          '/images/products/guardrail/line-navigator3.jpg',
          '/images/products/guardrail/line-navigator2.jpg',
        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>


      <ProductDetailNav
        category="guardrail"
        currentPath="/products/guardrail/line-navigator"
        listPath="/products/guardrail"
      />


      <CTASection />
    </>
  );
};

export default LineNavigator;
